import React from 'react';
import { TimeDividerStyle, TimedealTextStyle, TimedealTimeStyle, TimedealTitleStyle, TimedealInfoStyle } from './style';

interface WidgetPreviewTimedealInfoProps {
  title?: string;
  subTitle?: string;
}

const TimeDivider = () => {
  return (
    <TimeDividerStyle>
      <div className="dot" />
      <div className="dot" />
    </TimeDividerStyle>
  );
};

const WidgetPreviewTimedealInfo = (props: WidgetPreviewTimedealInfoProps): JSX.Element => {
  const { title, subTitle } = props;
  return (
    <TimedealInfoStyle>
      {title ? (
        <TimedealTextStyle>{title}</TimedealTextStyle>
      ) : (
        <p className="require-info">위젯 타이틀을 설정해주세요.</p>
      )}
      <TimedealTimeStyle>
        <span>00</span>
        <TimeDivider />
        <span>00</span>
        <TimeDivider />
        <span>00</span>
      </TimedealTimeStyle>
      {subTitle ? (
        <TimedealTitleStyle>{subTitle}</TimedealTitleStyle>
      ) : (
        <p className="require-info">위젯 서브 타이틀을 설정해주세요.</p>
      )}
    </TimedealInfoStyle>
  );
};

export default WidgetPreviewTimedealInfo;
